// The September 2026 referral campaign, mirrored from referral_controller's
// KEY_BTS_2026_SEPTEMBER_SCRAMBLE. Unlike the other campaign keys, nothing enrols teachers into
// this one from the client: the backend does it whenever an account reads /user. The key is here
// because it also decides who may reach /referral — an operator pointing it at a program through
// referral-program-configuration is what opens that page to teachers.
export const SEPTEMBER_SCRAMBLE_PROGRAM_KEY = 'bts_2026_september_scramble';

// Its email-recruited sibling, mirrored from KEY_BTS_2026_SEPTEMBER_EXTRA. Teachers join by
// following `?enroll=email_september_extra` (see referralEnrolment.js), never by visiting, so
// this key opens /referral for the same reason the Scramble's does: whoever the link enrolled
// has to be able to see what they joined.
export const SEPTEMBER_EXTRA_PROGRAM_KEY = 'bts_2026_september_extra';
